import {
  DEFAULT_SETTINGS,
  type SettingsRecord,
  type SettingsRepository,
} from "@/domain";

import type { MarginaliaDatabase } from "./database";
import { toStorageWriteError } from "./storage-errors";

function createDefaultSettings(): SettingsRecord {
  return {
    key: DEFAULT_SETTINGS.key,
    value: { ...DEFAULT_SETTINGS.value },
  };
}

export class DexieSettingsRepository implements SettingsRepository {
  constructor(private readonly db: MarginaliaDatabase) {}

  async get(): Promise<SettingsRecord> {
    return (await this.db.settings.get("application")) ?? createDefaultSettings();
  }

  async put(record: SettingsRecord): Promise<void> {
    try {
      await this.db.settings.put(record);
    } catch (error) {
      throw toStorageWriteError(error, "save application settings");
    }
  }
}
